import { useState } from "react";
import { BacktestingData } from "./NiftyStatergy";
import './BackTestingTable.scss'

interface TableProps {
  data: BacktestingData | null;
}

const Table = ({ data }: TableProps) => {
  const [sortConfig, setSortConfig] = useState<{
    key: "parameter" | "value";
    direction: "ascending" | "descending";
  } | null>(null);

  if (!data?.Backtesting) return null;

  const rawData = Object.keys(data.Backtesting).map((key) => ({
    parameter: key,
    value: data.Backtesting![key],
  }));

  const handleSort = (key: "parameter" | "value") => {
    let direction: "ascending" | "descending" = "ascending";
    if (sortConfig?.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key: "parameter" | "value") => {
    if (!sortConfig || sortConfig.key !== key) return " ↕";
    return sortConfig.direction === "ascending" ? " ↑" : " ↓";
  };

  const sortedData = [...rawData].sort((a, b) => {
    if (!sortConfig) return 0;
    const { key, direction } = sortConfig;
    const aVal = a[key];
    const bVal = b[key];
    const aNum = parseFloat(aVal);
    const bNum = parseFloat(bVal);
    let cmp: number;
    if (!isNaN(aNum) && !isNaN(bNum)) {
      cmp = aNum - bNum;
    } else {
      cmp = aVal.localeCompare(bVal);
    }
    return direction === "ascending" ? cmp : -cmp;
  });

  return (
    <div className="backtesting-table">
      <div className="title">Back Testing Result</div>
      <div className="table-wrapper">
      <table className="table table-striped">
        <thead>
          <tr>
            <th onClick={() => handleSort("parameter")} style={{ cursor: "pointer" }}>
              Parameters{getSortIcon("parameter")}
            </th>
            <th onClick={() => handleSort("value")} style={{ cursor: "pointer" }}>
              Values{getSortIcon("value")}
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((row) => (
            <tr key={row.parameter}>
              <td>{row.parameter}</td>
              <td>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default Table;
